import { useState, useEffect, useCallback } from 'react';
import { getInstallPrompt, clearInstallPrompt, onInstallPromptChange } from '@services/serviceWorker';

const isIos = () => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true;
    }

    // iPadOS 13+ reports as MacIntel but has touch support
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
        return true;
    }

    return false;
};

const getPlatform = () => {
    if (isIos()) return 'ios';
    if (/android/i.test(navigator.userAgent || navigator.vendor)) return 'android';
    return 'desktop';
};

const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;

export const useInstallApp = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(getInstallPrompt);
    const [isInstalled, setIsInstalled] = useState(isStandalone);
    const platform = getPlatform();

    useEffect(() => {
        return onInstallPromptChange(prompt => {
            setDeferredPrompt(prompt);
            if (!prompt) setIsInstalled(true);
        });
    }, []);

    const install = useCallback(async () => {
        if (!deferredPrompt) return false;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        setDeferredPrompt(null);
        clearInstallPrompt();
        return outcome === 'accepted';
    }, [deferredPrompt]);

    return {
        platform,
        isInstalled,
        canInstall: !!deferredPrompt,
        install,
    };
};
